import phoneNumberInputHelper from "../../../../../../common/components/form/input/phone-number/phone-number-input.helper";
import { FormValidationDefinition } from "../../../../../../common/components/form/use-form";
import cargoOfficerAddByCargoFormValidationService from "./cargo-officer-add-by-cargo-form-validation.service";
import CargoOfficerAddByCargoFormData from "./types/cargo-officer-add-by-cargo-form-data";

const getDefaultFormData = (): CargoOfficerAddByCargoFormData => {
  return {
    firstName: "",
    lastName: "",
    email: "",
    username: "",
    password: "",
    passwordRepeat: "",
    phoneNumber: phoneNumberInputHelper.getEmptyValue(),
    alternativePhoneNumber: phoneNumberInputHelper.getEmptyValue(),
  };
};

const getValidationDefinition =
  (): FormValidationDefinition<CargoOfficerAddByCargoFormData> => {
    return {
      alternativePhoneNumber: (values) =>
        cargoOfficerAddByCargoFormValidationService.validateAlternativePhoneNumber(
          values.alternativePhoneNumber
        ),
      email: (values) =>
        cargoOfficerAddByCargoFormValidationService.validateEmail(values.email),
      firstName: (values) =>
        cargoOfficerAddByCargoFormValidationService.validateFirstName(
          values.firstName
        ),
      lastName: (values) =>
        cargoOfficerAddByCargoFormValidationService.validateLastName(
          values.lastName
        ),
      password: (values) =>
        cargoOfficerAddByCargoFormValidationService.validatePassword(
          values.password
        ),
      passwordRepeat: (values) =>
        cargoOfficerAddByCargoFormValidationService.validatePasswordRepeat(
          values.password,
          values.passwordRepeat
        ),
      phoneNumber: (values) =>
        cargoOfficerAddByCargoFormValidationService.validatePhoneNumber(
          values.phoneNumber
        ),
      username: async (values) =>
        await cargoOfficerAddByCargoFormValidationService.validateUsername(
          values.username
        ),
    };
  };

const cargoOfficerByCargoAddFormHelper = {
  getDefaultFormData,
  getValidationDefinition,
};

export default cargoOfficerByCargoAddFormHelper;
